import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

export const createFixedAssetReq = (action) => {
    const { societyId, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.CREATE_FIXED_ASSET_API.replace(':societyId', societyId);
    return axiosInstance.post(url, payload);
}

export const getFixedAssetsReq = (action) => {
    const { societyId, year } = action?.data || {};
    const url = apiEndpoints.GET_FIXED_ASSETS_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params: { year } });
}

export const getDepreciationMethodsReq = () => {
    return axiosInstance.get(apiEndpoints.GET_DEPRECIATION_METHODS_API);
}

export const getFixedAssetCategoriesReq = (action) => {
    const { societyId } = action?.data || {};
    const url = apiEndpoints.GET_FIXED_ASSET_CATEGORIES_API.replace(':societyId', societyId);
    return axiosInstance.get(url);
}

export const getFixedAssetDetailsReq = (action) => {
    const { societyId, id } = action?.data || {};
    const url = apiEndpoints.GET_FIXED_ASSET_DETAILS_API
        .replace(':societyId', societyId)
        .replace(':id', id);
    return axiosInstance.get(url);
}

export const updateFixedAssetReq = (action) => {
    const { societyId, id, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.UPDATE_FIXED_ASSET_API
        .replace(':societyId', societyId)
        .replace(':id', id);
    return axiosInstance.put(url, payload);
}

export const deleteFixedAssetReq = (action) => {
    const { societyId, id } = action?.data || {};
    const url = apiEndpoints.DELETE_FIXED_ASSET_API
        .replace(':societyId', societyId)
        .replace(':id', id);
    return axiosInstance.delete(url);
}
